const LOGIN = "/auth/login",
    REGISTER_URL = '/auth/register',
    WINERIES = '/wineries',
    RESET = '/reset',
    WINELABELS = '/winelabels',
    VARIETIES = '/varieties',
    LABELS = '/labels',
    TANKS = '/tanks',
    SENSORS = '/sensors',
    OPERATIONS = '/operations',
    NOTE = '/note',
    USER = '/user',
    USERS = '/users',
    ME = '/me',
    RBAC = '/rbac',
    VERIFY = '/verify',
    AUTH = '/auth',
    LOTS = '/batches',
    TRACKING = '/tracking',
    TREE = '/tree',
    SUBSTATES = '/substates',
    PROTOCOLS = '/protocols',
    UPLOAD_DATASHEET = '/upload_datasheet',
    RESULTS = '/results',
    RECURRENT = '/recurrent',
    DRUGS = '/drugs',
    WAREHOUSE = '/warehouse',
    CAPS = '/caps',
    ANALYSIS = '/analysis',
    CLIENTS = '/clients',
    CLIENT_NAME = '/client_name',
    RESET_PASSWORD = '/reset-password',
    WINEMAKING = '/winemaking',
    OIV = '/oiv',
    SUBSTANCES = '/SUBSTANCES',
    STATE = '/state',
    START = '/start',
    WORK_MODE = '/work_mode',
    APPLY = '/apply',
    UTILS = '/utils',
    REPORT = '/report',
    COOKIE = '/cookie',
    HISTORY = '/history',
    COUNT = '/count',
    EXPIRED = '/expired',
    UNITS='/units',
    UPDATE='/update',
    ROLES='/roles',
    RESOURCES='/resources',
    RESEND='/resend',
    SETTINGS='/settings',
    PERMISSIONS='/permissions',
    EMAIL='/email',
    QR='/qr',
    NEW_PASSWORD='/new-password',
    PDF = '/create-pdf',
    EXCEL = '/create-excel',
    DICTIONARY = '/dictionary',
    TOKEN_KEY = 'auth',
    STICKY_NOTE = '/sticky-note',
    CLOSE = '/CLOSE',
    ROLLBACK = '/rollback',
    BUYERS = '/buyers',
    POMACES = '/pomaces',
    SUPPLIERS = '/suppliers',
    VINEYARDS = '/vineyards',
    PROTOCOL_APPLICATIONS = '/protocol-applications',
    WINEMAKING_PROTOCOLS = '/winemaking-protocols',
    AUDIT_LOG = '/audit-log',
    ERROR_REPORTS = '/admin/error-reports',
    IMPERSONATE = '/impersonate',
    STOP = '/stop',
    ANNOUNCEMENTS = '/announcements',
    ADMIN_ANNOUNCEMENTS = '/admin/announcements',
    DISMISS = '/dismiss',
    DEACTIVATE = '/deactivate'

export {
    LOGIN,
    REGISTER_URL,
    TOKEN_KEY,
    WINERIES,
    RESET,
    WINELABELS,
    LABELS,
    VARIETIES,
    TANKS,
    SENSORS,
    LOTS,
    OPERATIONS,
    NOTE,
    PROTOCOLS,
    UPLOAD_DATASHEET,
    RESULTS,
    RECURRENT,
    USERS,
    ME,
    RBAC,
    VERIFY,
    AUTH,
    USER,
    DRUGS,
    WAREHOUSE,
    CAPS,
    ANALYSIS,
    CLIENTS,
    CLIENT_NAME,
    RESET_PASSWORD,
    WINEMAKING,
    OIV,
    SUBSTANCES,
    STATE,
    START,
    WORK_MODE,
    APPLY,
    HISTORY,
    COUNT,
    EXPIRED,
    UTILS,
    REPORT,
    COOKIE,
    TRACKING,
    TREE,
    SUBSTATES,
    UNITS,
    UPDATE,
    ROLES,
    RESOURCES,
    RESEND,
    SETTINGS,
    EMAIL,
    QR,
    PERMISSIONS,
    NEW_PASSWORD,
    PDF,
    EXCEL,
    DICTIONARY,
    STICKY_NOTE,
    CLOSE,
    ROLLBACK,
    BUYERS,
    POMACES,
    SUPPLIERS,
    VINEYARDS,
    PROTOCOL_APPLICATIONS,
    WINEMAKING_PROTOCOLS,
    AUDIT_LOG,
    ERROR_REPORTS,
    IMPERSONATE,
    STOP,
    ANNOUNCEMENTS,
    ADMIN_ANNOUNCEMENTS,
    DISMISS,
    DEACTIVATE
}